import { render, staticRenderFns } from "./UserLogo.vue?vue&type=template&id=0215a22e&scoped=true&"
import script from "./UserLogo.vue?vue&type=script&lang=ts&"
export * from "./UserLogo.vue?vue&type=script&lang=ts&"
import style0 from "./UserLogo.vue?vue&type=style&index=0&id=0215a22e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0215a22e",
  null
  
)

export default component.exports